import { useState, useEffect } from 'react';
import { AppBar, Box, Toolbar, Typography, Tab, Tabs } from '@material-ui/core';
import TabPanel from './TabPanel';
import { getPromotionCriteriaDataFilter } from '../../../../Utils/apiServices';
import KenLoader from '../../../../Components/KenLoader/index';
import KenSnackbar from '../../../../Components/KenSnackbar/index';
import { useTranslation } from 'react-i18next';
import Promotion from './Promotion';
import { makeStyles } from '@material-ui/styles';

const PromotionMaster = () => {
  const useStyles = makeStyles((theme) => ({
    breadCrumbWrapper: {
      margin: '15px 0',
    },
    header: {
      background: '#ffffff',
      color: theme.palette.KenColors.primary,
    },
    title: {
      fontSize: 18,
      fontWeight: 600,
    },
    holidayButton: {
      textTransform: 'none',
      fontWeight: 'bold',
      marginRight: '5px',
    },
    fitlerButton: {
      textTransform: 'none',
      fontWeight: 'bold',
    },
    sortingSection: {
      display: 'grid',
      gap: '10px',
      gridTemplateColumns: 'repeat(7, 1fr)',
    },
    mainActions: {
      textAlign: 'right',
    },
    popOverHeading: {
      width: '100%',
      fontSize: '14px',
      fontWeight: '400',
      color: '#02195E',
    },
    tableBodyStyle: {
      fontSize: '12px',
      color: '#7A869A',
    },
    tableBodyStyleIgnoreHoliday: {
      fontSize: '12px',
      color: '#7A869A',
      padding: '0px',
    },
    textInputFieldDropDown: {
      background: 'transparent',
      borderRadius: '4px',
      color: '#000',
    },
    textInputField: {
      background: 'transparent',
      borderRadius: '4px',
      color: '#000',
    },
    kenDateTimePickerColor: {
      backgroundColor: '#fff',
    },
  }));
  const classes = useStyles();

  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [CriteriaType, setCriteriaType] = useState('');
  const [FeeStatus, setFeeStatus] = useState('');
  const [Grade, setGrade] = useState('');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [opertionFilter, setopertionFilter] = useState([]);
  const [title, setTitle] = useState('');
  const [criteriaName, setcriteriaName] = useState('');

  const { t } = useTranslation();

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  useEffect(() => {
    setLoading(true);
    getPromotionCriteriaDataFilter()
      .then((res) => {
        let CriteriaType = [];
        let FeeStatus = [];
        let Grade = [];
        let Opertion = [];

        Object.entries(res['CriteriaType']).map(([item, keyVal]) => {
          CriteriaType.push({
            active: keyVal.active,
            defaultValue: keyVal.defaultValue,
            label: keyVal.label,
            validFor: keyVal.validFor,
            value: keyVal.value,
          });
        });
        Object.entries(res['FeeStatus']).map(([item, keyVal]) => {
          FeeStatus.push({
            label: keyVal,
            value: keyVal,
          });
        });
        Object.entries(res['Grade']).map(([item, keyVal]) => {
          Grade.push({
            label: keyVal,
            value: keyVal,
          });
        });
        Object.entries(res['FilterOperator']).map(([item, keyVal]) => {
          Opertion.push({
            label: keyVal.label,
            value: keyVal.value,
          });
        });
        CriteriaType.map((type) => {
          return setcriteriaName(type.name);
        });
        setopertionFilter(Opertion);
        setGrade(Grade);
        setFeeStatus(FeeStatus);
        setCriteriaType(CriteriaType);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        handleSnackbarOpen('error', t(err.message));
      });
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}></Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Promotion Criteria
          </Typography>
        </Toolbar>
      </AppBar>
      <Box className={classes.breadCrumbWrapper}></Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          className={classes.header}
        >
          {CriteriaType.length > 0 &&
            CriteriaType?.map((criteriaName) => {
              return <Tab label={criteriaName.label} />;
            })}
        </Tabs>
      </Box>

      {CriteriaType.length > 0 &&
        CriteriaType?.map((criteriaName, index) => {
          return (
            <TabPanel value={value} index={index}>
              <Promotion
                criteriaNameLabel={criteriaName.label}
                FeeStatus={FeeStatus}
                Grade={Grade}
                title={title}
                opertionFilter={opertionFilter}
              />
            </TabPanel>
          );
        })}

      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
    </Box>
  );
};

export default PromotionMaster;
